import React, { Fragment } from 'react';
import './curved.scss';
import { ConditionalButton } from '../Buttons/Buttons';
import { useStyles } from './cards.style';
import { CommonButtonTypes } from 'Common/Types/Types';
import resetIt from 'Assets/img/svg/icons/resetPassword.svg';

interface ConditionalCardProps extends CommonButtonTypes {
	heading?: string | undefined;
	information?: string | undefined;
	onClick?: any | undefined;
	conditions?: Array<{ id: number; name: string }> | undefined;
	id?: number | undefined;
	image?: any;
	children?: any;
	headingStyle?:any;
}
const ConditionalCard = ({
	common,
	heading,
	information,
	onClick,
	conditions,
	image,
	children,
	id,
	headingStyle
}: ConditionalCardProps) => {
	const classes = useStyles({ common });
	// eslint-disable-next-line no-console
	console.log("this --->",id)
	return (
		<Fragment>
			<section className={classes.card}>
				<div className={classes.curved}>
					<img src={image ? image : resetIt} className={classes.image} alt="" />
				</div>
				<div className="px-4">
					<h6 className={`${classes.heading  } ${headingStyle && classes.headingEnlarge}` } >{heading}</h6>
					<p style={{ paddingBottom: conditions && conditions?.length < 0 ? '1rem' : '' }}>{information}</p>
				</div>
				<div>
					{children}
					<ul className={`${classes.listStyle} d-flex flex-nowrap justify-content-center`}>
						{conditions?.map(condition => (
							<li key={condition.id} className="mx-4 my-4">
								
								<ConditionalButton condition={condition.name} onClick={() => onClick(condition.name,id)} />
								
							</li>
						))}
					</ul>
				</div>
			</section>
		</Fragment>
	);
};

export default ConditionalCard;
